import React from "react";
import lightbulb from "../assets/lightbulb.png";

const text =
  "In order to complete the process, you have to correctly upload the required documentation for each step. You can only advance to the next level if there are no errors in the submitted file. ";
const [textFirstPart, textSecondPart] = text.split(". ");

const styleSheet = {
  container: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f5f7fe", // light grey color
    padding: "15px",
    margin: "25px 0", // spacing above and below the callout
    borderRadius: "5px",
  },
  callout: {
    display: "flex",
    flex: 1,
    fontSize: "16px",
    border: "0px solid grey", // dark greyish blue color

    color: "#59515e", // dark greyish blue color
    fontWeight: "light", // bold font
  },
  imgContainer: {
    width: "45px",
    height: "45px",
    border: "0px solid black",
    marginRight: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    padding: "5px",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "auto",
  },
};

const Callout = () => {
  return (
    <div style={styleSheet.container}>
      <div style={styleSheet.imgContainer}>
        <img src={lightbulb} alt="lightbulb" style={styleSheet.image} />
      </div>
      <div style={styleSheet.callout}>
        {textFirstPart}.<br />
        {textSecondPart}.
      </div>
    </div>
  );
};

export default Callout;
